var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolidaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "#7F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8247 20.6676V30H12.6151V8.18182H17.6542V16.6406H17.8353C18.2046 15.6321 18.8083 14.8438 19.6464 14.2756C20.4916 13.7074 21.5249 13.4233 22.7465 13.4233C23.8971 13.4233 24.8985 13.679 25.7508 14.1903C26.6031 14.6946 27.2636 15.4084 27.7323 16.3317C28.2082 17.255 28.4426 18.3345 28.4355 19.5703V30H23.2259V20.593C23.233 19.6839 23.0058 18.9737 22.5441 18.4624C22.0825 17.951 21.4326 17.6953 20.5945 17.6953C20.0477 17.6953 19.5647 17.8161 19.1457 18.0575C18.7338 18.2919 18.4106 18.6293 18.1762 19.0696C17.949 19.5099 17.8318 20.0426 17.8247 20.6676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaLogo);
export default __webpack_public_path__ + "static/media/HolidaLogo.540a033a796372663f76565514f33e21.svg";
export { ForwardRef as ReactComponent };